export const initial = {
  nr: null,
  gemeinde: null,
  flurname: null,
  radius: null,
  hoehe: null,
  exposition: null,
  klima: null,
  neigung: null,
  bodenTyp: null,
  bodenKalkgehalt: null,
  bodenDurchlaessigkeit: null,
  bodenHumus: null,
  bodenNaehrstoffgehalt: null,
  bodenAbtrag: null,
  wasserhaushalt: null,
  beschreibung: null,
  katasterNr: null,
  status: null,
  statusUnklar: null,
  statusUnklarGrund: null,
  apberRelevant: null,
  bekanntSeit: null,
  eigentuemer: null,
  kontakt: null,
  nutzungszone: null,
  bewirtschafter: null,
  bewirtschaftung: null,
  ekfrequenz: null,
  ekfrequenzAbweichend: null,
  ekfrequenzStartjahr: null,
  ekfKontrolleur: null,
  bemerkungen: null,
}

export const simpleTypes = {
  nr: 'number',
  gemeinde: 'string',
  flurname: 'string',
  radius: 'number',
  hoehe: 'number',
  exposition: 'string',
  klima: 'string',
  neigung: 'string',
  bodenTyp: 'string',
  bodenKalkgehalt: 'string',
  bodenDurchlaessigkeit: 'string',
  bodenHumus: 'string',
  bodenNaehrstoffgehalt: 'string',
  bodenAbtrag: 'string',
  wasserhaushalt: 'string',
  beschreibung: 'string',
  katasterNr: 'string',
  status: 'number',
  statusUnklar: 'boolean',
  statusUnklarGrund: 'string',
  apberRelevant: 'boolean',
  apberRelevantGrund: 'number',
  bekanntSeit: 'number',
  eigentuemer: 'string',
  kontakt: 'string',
  nutzungszone: 'string',
  bewirtschafter: 'string',
  bewirtschaftung: 'string',
  ekfrequenz: 'uuid',
  ekfrequenzAbweichend: 'boolean',
  ekfrequenzStartjahr: 'number',
  ekfKontrolleur: 'uuid',
  bemerkungen: 'string',
}
